import makeStyles from '@mui/styles/makeStyles'

const BORDER = '0.0625rem solid rgba(230, 234, 236, 0.9)'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    backgroundColor: '#E4E8EA',

    '& > div': {
      display: 'flex'
    }
  },

  header: {
    borderTop: BORDER,
    borderBottom: BORDER
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '0.75rem',
    padding: '0.5rem 0',
    fontSize: theme.size.base,

    '& .icon': {
      transform: ({ expanded }) => `rotate(${expanded ? 90 : 0}deg)`,
      transition: 'transform 300ms',
      fontSize: theme.size.lg,
      color: theme.palette.primary.main,
      cursor: 'pointer'
    }
  },

  name: {
    margin: '0 0.5rem',
    color: theme.palette.textLight
  },

  count: {
    marginTop: '2px',
    marginRight: '0.25rem',
    fontSize: theme.size.sm,
    color: theme.palette.primary.main
  },

  edit: {
    display: 'flex',
    alignItems: 'center',
    width: '1rem',
    height: '100%',
    opacity: '0.35',
    cursor: 'pointer',
    color: theme.palette.textAlt
  },

  nav: {
    position: 'absolute',
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    gridColumnGap: '0.75rem',
    fontSize: theme.size.lg,
    color: theme.palette.primary.main,
    userSelect: 'none',

    '& > div': {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer'
    },

    '& span': {
      fontSize: theme.size.sm
    }
  },

  views: {
    height: '100%',
    marginRight: '27px'
  },

  searchBar: {
    borderBottom: BORDER
  },

  filters: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '1rem',

    '& > :not(:last-child)': {
      marginRight: '0.5rem'
    }
  },
  add: {
    zIndex: ({ adjust }) => (adjust ? '1' : '0'),
    display: 'flex',
    alignItems: 'center',
    marginTop: ({ adjust }) => (adjust ? '-1rem' : '0'),
    borderBottom: '0.0625rem solid rgba(230, 234, 236, 0.9)',
    padding: '10px 0',
    color: theme.palette.textAlt,
    fontSize: theme.size.sm
  },

  addButton: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '1rem',
    cursor: 'pointer',
    opacity: '0.455',

    '& .icon': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '0.5rem',
      fontSize: theme.size.base
    }
  }
}))

export default useStyles
